import AvailableMeal from "./AvailableMeal";
import MealSummary from "./MealSummary";
let Meal = () => {
    return (
        <>
            <MealSummary></MealSummary>
            <AvailableMeal></AvailableMeal>
        </>
    )
}

export default Meal;